<template>
    <v-dialog max-width="800px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Lịch sử
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
                <v-icon>cancel</v-icon>
            </v-btn>
          <v-card-text>
            <table class="lstTable" v-if="lstHistory.length>0">
              <tr>
                <th width="20%">Thời gian</th>
                <th width="15%">Người xử lý</th>
                <th width="15%">Xử lý</th>
                <th width="50%">Nội dung</th>
              </tr>
              <tr v-for="item in lstHistory">
                <td>{{item.actionTime|formatDateTime}}</td>
                <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                <td>{{item.action}}</td>
                <td><label v-if="item.actionContent"> {{item.actionContent}}</label></td>

              </tr>
            </table>
            <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
            </div>
          </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.close") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {message} from "@/shared/message";

export default {
    name: "dialog_history",
    components: { },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
      lstHistory: {
          type: Array,
          default:  () => []
      }
    },
    data: () => {
        return {

        };
    },

    watch: {
        
    },

    created() {
        
    },

    methods: {
        close() {
            this.$emit("close");
        },
    },
    destroyed() {},
};
</script>
